export default __webpack_public_path__ + "static/card-4-2139795e6b17084bea9cf5841dce8f71.png";